import { observable } from 'mobx';
import { PayerOnboardingPage } from '../index';
import { ValidationState, validateFields } from '../../../WebGiving/validation/view-model-validator';
import { PayerOnboardingPageViewModelBase } from '../payer-onboarding-page-view-model';
import { PaymentLabel, AppContentCardModel } from '../../payer-onboarding-generated';

export class PageSuccessViewModel extends PayerOnboardingPageViewModelBase {
	readonly type: PayerOnboardingPage = PayerOnboardingPage.Success;

	appContentCard: AppContentCardModel | null;

	@observable
	validationState?: ValidationState;

	validate(): ValidationState {
		return validateFields(this);
	}

	constructor(
		public readonly firstName: string,
		public readonly paymentLabel: PaymentLabel,
		public readonly getAppUrl: string,
		public readonly merchantAppName: string,
		public readonly hasCustomApp: boolean,
		public readonly hasWelcomeSmsBeenSent: boolean,
		appContentCardData: AppContentCardModel[] | null,
	) {
		super();
		this.appContentCard = appContentCardData && appContentCardData.length ? appContentCardData[0] : null;
	}
}
